import styled, { keyframes } from 'styled-components'

import { DebounceInput } from 'react-debounce-input'
import { hideOnMobile } from '../constants'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Tooltip from 'react-bootstrap/Tooltip'
import {
  sideBarWidthPercent,
  mobileBreakpoint,
  backgroundColor
} from '../constants'


export const Header = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextSearchBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  @media (max-width: ${mobileBreakpoint}px){flex-direction: column;}
`

export const AddLabelDiv = styled.div`
  display: flex;
`

export const StyledDebounceInput = styled(DebounceInput)`
  font-size: 16px;
  padding: 12px 50px;
  border-radius: 20px;
  border: 2px solid #93bded;
  background-image: url(https://cdn2.hubspot.net/hubfs/4004166/bioticresearch_website_assets/images/search_icon.png);
  background-repeat: no-repeat;
  background-position: left center;
`

export const CustomButton = styled(Button)`
  padding-bottom: 27px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 10px;
  height: 2em;
  border-radius: 25px;
  border: 2px solid #93bded;
  @media (max-width: ${mobileBreakpoint}px) {
    padding-left: 0;
    margin-left: 0;
    margin-top: 10px;
  }
`

export const FilterResultCountSpan = styled.span`
  opacity: 0.5;
  font-size: 0.89em;
  display: flex;
  ${hideOnMobile}
`

export const AppContainer = styled.div`
  font-family: Roboto, sans-serif;
  text-align: left;
  margin-bottom: 40px;
  padding-left: 10px;
  padding-right: 10px;
  @media (min-width: ${mobileBreakpoint + 1}px) {
    margin-left: ${sideBarWidthPercent}%;
  }
  max-width: 1000px
`

export const Container = styled.div`
  margin-top: 10px;
  border-top: 2px solid #999;
`

export const H1 = styled.h1`
  font-size: 1.4em;
  font-weight: 400;
  color: #2c3e50;
  margin: 0;
  padding: 0 1rem;
  ${hideOnMobile}
`

export const IconContainer = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-shrink: 0;
  gap: 0;
  @media (max-width: ${mobileBreakpoint + 400}px) {
    flex-direction: column;
    margin-top: -10px;
    margin-right: -15px;
  }
`

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const AuthorNameH3 = styled.h3`
  background-image: linear-gradient(to right, #fefefe, #eee);
  border-radius: 0.5em;
  padding: 0.5em 0 0.5em;
  margin-bottom: 0;
  font-size: 1.3em;
`

export const DocumentTitleH4 = styled.h4`
  font-size: 1.1em;
  text-decoration: underline;
  color: #444;
  font-weight: 200;
  margin-top: 10px;
  margin-bottom: 20px;
`

export const ClippedAtSpan = styled.span`
  color: grey;
  display: block;
  font-size: 0.8em;
  margin-bottom: 5px;
`

export const ClippingFooter = styled.div`
  display: flex;
  align-items: baseline;
  > *:first-child {
    margin-right: 10px;
  }
  > *:not(:first-child) {
    margin-left: 10px;
  }
`

export const Label = styled.span`
  display: inline-block;
  background: darkred;
  border-radius: 3px;
  color: white;
  font-size: .8em;
  padding: 0 5px;
`

const defaultA = styled.a`
  cursor: pointer;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: black;
`

export const A = styled(defaultA)`
  display: block;
  text-align: left;
  margin-bottom: 5px;
  min-width: 200px;
  border: 1px solid #aaa;
`

export const Clippings = styled.div`
  background: white;
  padding: 1em 0 1em;
  @media (min-width: ${mobileBreakpoint + 1}px) {
    margin: 0em 1.5em 1em;
    padding: 20px;
  }
  min-height: 7em;
`

export const QuotePWrapper = styled.div`
  margin-bottom: 1em;
  border-bottom: 1px solid #ddd;
  position: relative;
  @media (max-width: ${mobileBreakpoint + 1}px) {
    padding-top: 12px;
  }
`

export const QuoteTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const QuoteP = styled.p`
  border-left: solid 4px #F2E366;
  padding-left: 15px;
  margin-left: -15px;
  display: flex;
  flex-direction: row;
  padding-right: 50px;
  @media (max-width: ${mobileBreakpoint}px){ 
    padding-left: 10px;
    margin-left: -20px;
    padding-right: .2em;
    margin-right: 0;
  }
`

export const IconButton = styled(Button)`
  color: ${props => props.color || 'grey'};
  background: none;
  border: none;
  cursor: pointer;
  svg {
    width: 24px;
    pointer-events: none;
  }
  > .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
  }
`

export const ResultBox = styled.div`
  padding: 1em;
  @media (max-width: ${mobileBreakpoint}px) {
    padding: 0.5em;
  }
`

export const HeaderDiv = styled.div`
  padding: 1rem 2rem;
  margin: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  
  @media (max-width: ${mobileBreakpoint}px) {
    padding: 0.75rem 1rem;
    margin: 0;
  }
`

export const UploadDiv = styled.div`
  padding: 10px 0 10px 10px;
  display: flex;
  flex-direction: column;
  width: 300px;
  margin-left: 10px;
  ${hideOnMobile}
`

export const UploadFile = styled.input`
  align-self: center;
  cursor: pointer;
  font-weight: 300;
  margin-bottom: 5px;
`

export const UploadLabel = styled.label`
  font-size: 0.9em;
  margin-left: -50px;
  margin-bottom: 10px;
  align-self: center;
`

export const SettingsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  
  @media (max-width: ${mobileBreakpoint}px) {
    gap: 0.75rem;
  }
`

export const ProfileDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const ProfilePic = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`

export const Spinner = styled.div`
  position: absolute;
  top: 50px;
`

export const WelcomeDiv = styled.div`
  display: flex;
  flex-direction: row;
`

export const WelcomeP = styled.span`
  padding: 0;
  margin: 0;
`

export const LogOutButton = styled(Button)`
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 15px 5px;
  margin-left: 20px;
  align-self: center;
  min-width: 100px;
  @media (max-width: ${mobileBreakpoint}px){
    position: absolute;
    right: 20px;
  }
`

export const ClipMeLogo = styled.span`
  color: #4a90e2;
  font-weight: 700;
  font-family: Roboto, sans-serif;
  font-size: 1.5em;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #357abd;
  }
  
  ${hideOnMobile}
`

export const LoadingMoreClippings = styled.div`
  padding: 15%;
  margin: 15%Button /;
  opacity: 0.7;
`

export const BadgeLabel = styled.span`
 position: relative;
 margin: 10px;
 cursor: default;
`

export const OtherBadgeLabel = styled.span`
 position: relative;
 margin: 2px;
 cursor: pointer;
`

export const StyledBadgeDelete = styled.div`
  display: none;
  ${BadgeLabel}:hover & {
    display: inline;
  }
  ${OtherBadgeLabel}:hover & {
    display: inline;
  }
  border-radius: 1em;
  padding: 15px;
  position: absolute;
  top: -25px;
  right: -25px;
  color: red;
  opacity: 80%;
  cursor: pointer;
  font-size: .7em;
`

export const ClickableBadge = styled(Badge).attrs(props => ({
  active: props.active
}))`
  cursor: pointer;
  padding: 5px 15px 5px;
  margin: 3px;
  opacity: ${props => props.active ? '1' : '0.6'}
`

const FadeAnimation = keyframes`
  0% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
`

const spinAnimation = keyframes`
  to { transform: rotate(360deg); }
`

export const TtsSpinnerIcon = styled.svg.attrs({
  viewBox: '0 0 24 24',
  xmlns: 'http://www.w3.org/2000/svg'
})`
  width: 24px;
  height: 24px;
  animation: ${spinAnimation} 0.8s linear infinite;
`

export const AutoHidingTooltip = styled(Tooltip)`
 animation-name: ${FadeAnimation};
 animation-duration: 2s;
 visibility: hidden;
`

export const LabelsArea = styled.div`
 display: flex;
 flex-wrap: wrap;
`

export const SidebarButton = styled(Button)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  background: white;
  color: #4a5568;
  font-weight: 500;
  font-size: 0.875em;
  transition: all 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &:hover {
    background: #edf2f7;
    transform: translateY(-1px);
    border-color: #cbd5e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    color: #2d3748;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 14px;
    height: 14px;
    margin-right: 0.5rem;
    color: #718096;
  }

  &[data-active='true'] {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #2d3748;
    
    svg {
      color: #4a5568;
    }
  }
`

export const StyledSideBar = styled.div`
  width: ${sideBarWidthPercent}%;
  float: left;
  top: 20px;
  position: sticky;
  height: calc(100vh - 40px);
  overflow-x: hidden;
  overflow-y: auto;
  margin: 1rem 0;
  border-radius: 12px;
  background: ${backgroundColor};
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  @media (max-width: ${mobileBreakpoint}px) {
    display: none;
  }
`
